const now_domain = window.location.hostname;
// const isProduction = now_domain == "app.q23.co";
const isProduction = true;
const API_V1 = isProduction ? "https://api.q23.co" : "http://localhost:8080";
const API = { API_V1 };
export default API;
